// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"266444d2","453":"43f11d08"}[chunkId] + ".chunk.js";
};